import './styles.scss';
import React from 'react';
import {Route, Switch, withRouter} from "react-router-dom";
import {ConfigProvider, Layout} from "antd";
import NoData from '../../assets/undraw/no_data.svg'


/* App Imports */
import Protected from "../Protected/Protected";
import {QueryClientProvider} from "react-query";
import {queryClient} from "../../settings";
import {useAuth0} from "@auth0/auth0-react";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import AuthShell from "../../components/common/AuthShell/AuthShell";

function App() {
    const { isLoading, isAuthenticated } = useAuth0();

    if (isLoading) {
        return (
            <div className='default-loader-full' style={{height: '100vh'}}>
                <DefaultLoader text='Authenticating...'/>
            </div>
        )
    }
    if (!isAuthenticated) {
        return <AuthShell/>;
    }

    const renderEmpty = () => {
        return (
            <div className='global-empty'>
                <img alt="" src={NoData}/>
                <div>You don't have any data in here yet</div>
            </div>
        )
    }

    return (
        <ConfigProvider renderEmpty={renderEmpty}>
            <QueryClientProvider client={queryClient}>
                <Layout className='app' id='app' style={{minHeight: '100vh'}}>
                    <Switch>
                        <Route render={() => <Protected header sidebar/>}/>
                    </Switch>
                </Layout>
            </QueryClientProvider>
        </ConfigProvider>
    );
}

export default withRouter(App);
